import { render } from "./404.vue?vue&type=template&id=2ff88df9"
const script = {}
script.render = render

export default script